// 视频打标标签常量（前端静态枚举）
// 后续如需对接后端 id，仅需修改此处即可。

// 必选标签：单选必填
export const REQUIRED_TAGS = [
    { id: 1, name: '含AI生成内容' },
    { id: 2, name: '含虚拟演绎内容' },
    { id: 3, name: '内容含营销信息' },
    { id: 4, name: '内容为转载' },
    { id: 5, name: '个人观点，仅供参考' },
    { id: 6, name: '内容无需标注' }
]

// 可选标签：单选选填
export const OPTIONAL_TAGS = [
    { id: 1, name: '内容可能引人不适，请谨慎观看' },
    { id: 2, name: '内容含有高危险行为，请勿模仿' },
    { id: 3, name: '请理性适度消费' },
    { id: 4, name: '未成年人请在监护人指导下浏览' }
]

// 根据 id 查找标签名称，找不到返回 ''
export function getRequiredTagName(id) {
    const target = REQUIRED_TAGS.find(el => el.id === id)
    return target ? target.name : ''
}

export function getOptionalTagName(id) {
    const target = OPTIONAL_TAGS.find(el => el.id === id)
    return target ? target.name : ''
}
